import { FormPagePropertyItemSelectionRegistrationLimit } from 'backend';
import isAfter from 'date-fns/isAfter';

export const isUpperLimit = (
  limit: FormPagePropertyItemSelectionRegistrationLimit
): boolean => {
  return limit.upperLimit <= limit.registrationCount;
};

export const isOverDeadLine = (
  limit: FormPagePropertyItemSelectionRegistrationLimit,
  currentTime: string | undefined
): boolean => {
  if (limit.registrationDeadline == null || currentTime == null) {
    return false;
  }
  const now = new Date(currentTime);
  const deadline = new Date(limit.registrationDeadline);
  return isAfter(now, deadline);
};

export const isSelectableRegistrationLimitOption = (
  limit: FormPagePropertyItemSelectionRegistrationLimit | undefined,
  currentTime: string | undefined
): boolean => {
  if (limit == null) {
    return true;
  }
  if (limit.isAnswered) {
    return true;
  }
  return !isUpperLimit(limit) && !isOverDeadLine(limit, currentTime);
};
